import { render, staticRenderFns } from "./ProductApplicationGlobalFilter.vue?vue&type=template&id=51f3f83e&scoped=true&lang=html&"
import script from "./ProductApplicationGlobalFilter.vue?vue&type=script&lang=js&"
export * from "./ProductApplicationGlobalFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f3f83e",
  null
  
)

export default component.exports